import { maxAge } from '../constants';

const dateRegex =
  /^(?:(?:31(\/)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;

export const calculateAge = (birthdate: string) => {
  const birthDate = new Date(birthdate);
  const compareDate = new Date();

  let age = compareDate.getFullYear() - birthDate.getFullYear();
  const months = compareDate.getMonth() - birthDate.getMonth();

  if (months < 0 || (months === 0 && compareDate.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

export const getDefaultBirthDateString = (date: string) => {
  if (!dateRegex.test(date)) return '';

  const incomingDateInMs = new Date(date.split('/').reverse().join('-')).getTime();

  const maxDateInMs = new Date(new Date().setDate(new Date().getDate() - 1)).getTime();
  const minDateInMs = new Date(new Date().setFullYear(new Date().getFullYear() - maxAge)).getTime();

  if (incomingDateInMs > maxDateInMs || incomingDateInMs < minDateInMs) {
    return '';
  }

  return date;
};
